import { cn } from "@/lib/utils"
import { type SVGProps } from "react"

interface SvgLogoProps extends SVGProps<SVGSVGElement> {
  variant?: "default" | "enhanced"
}

export const SvgLogo = ({ variant = "default", ...props }: SvgLogoProps) => {
  const getClassName = () => {
    switch (variant) {
      case "enhanced":
        return "svg-enhanced"
      default:
        return ""
    }
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={400}
      height={400}
      viewBox="280 250 450 500"
      {...props}
      className={cn(getClassName(), props.className)}
    >
      <path
        d="M488.5 302.6c-27.7 4-44.4 8-62.1 14.9-71.3 28-125.1 88.5-140.5 158.2-1.9 8.7-2.2 13.6-2.6 44.3-.5 34.4-.5 34.4 4.4 29.9 6.7-6.3 14.8-11.4 21-13.4 5.1-1.7 5.4-1.9 8.9-9.4 2.7-5.6 5.5-9.3 10.4-14.1 6.7-6.5 6.7-6.5 7.3-15.5 1.6-22.8 12-49.2 28.1-71.8 45.7-64 128.9-91.2 205.1-67 42.5 13.5 80 43.7 102 82.2 9.8 17.1 17.1 39.7 18.2 56.6.6 9 .6 9 7.3 15.5 4.9 4.8 7.7 8.5 10.4 14.1 3.5 7.5 3.8 7.7 8.9 9.4 7.2 2.4 13 5.9 19.9 12.4 6 5.5 6 5.5 5.5-29.5-.4-33.5-.5-35.4-3-45.9-3.9-16.2-8.3-28.3-15.9-43.6-28.4-57.5-82.7-102.1-145.8-119.5-22-6.1-33.6-7.6-60.5-7.9-13.2-.2-25.3-.1-27 .1z"
        className="fill-primary"
      />
      <path
        d="M356.5 522.8c-6.6 2.3-10.9 5.4-14.3 10.5-4.1 6.1-4.5 7.2-5.1 17.7-.6 9.4-.6 9.4-7.2 9.7-16.7.6-30.7 12.1-34.5 28.2-2.1 8.6-1.9 58.7.1 66.6 4.2 15.8 17.1 26.3 33.6 27.3 7.7.4 7.7.4 8.1 10.1.5 10.7 1.8 14.2 7.7 20.4 8.1 8.6 21.7 11.8 35.4 8.2 9.9-2.6 15.9-7.4 19.9-16 2.3-5 2.3-5 2.3-84s0-79-2.3-83.7c-3.1-6.3-9.7-12.1-16.6-14.7-7.2-2.7-19.8-2.8-27.1-.3zM639.6 523.4c-7 2.9-12.8 8.3-15.9 14.6-2.2 4.5-2.2 4.5-2.2 83 0 74.6.1 78.7 1.9 83.4 4 10.4 14.2 17.2 27.5 18.3 11.6 1 21.6-2.3 28.2-9.4 5.9-6.2 7.2-9.7 7.7-20.4.4-9.7.4-9.7 8.1-10.1 16.7-1 29.5-11.5 33.6-27.7 1.4-5.2 1.6-11.2 1.3-36.4-.3-30.2-.3-30.2-3.6-36.9-6.3-12.8-18.2-20.6-32.1-21.1-6.6-.3-6.6-.3-7.1-9.7-.6-11-3-17-8.8-22.1-6.2-5.5-11.5-7.3-22.7-7.6-8.8-.3-10.7-.1-15.9 2.1zM522.1 544.7c-2.3 2.4-4.5 9.1-14.4 43.8-6.4 22.6-11.7 42-11.7 43.3 0 2.3-1.8 3.1-2.4.9-.2-.6-1.6-5.4-3.2-10.6-4-13.1-3.9-13.1-22.8-13.1-16.9 0-18.6.5-20.6 6.4-.9 2.7-.8 4.2.4 6.9 2.1 5 4.7 6.1 15.1 6.3 9 .1 9 .1 16.6 22.9 8.3 25 9.2 26.5 16.1 26.5 7.6 0 8.1-1.1 20.1-43 5.8-20.6 10.7-38.8 10.9-40.4.4-3.6 2.6-4.6 3.1-1.4 1.8 9.5 7.1 29.9 8.3 31.6 2.1 3.1 7.5 4.2 19.7 4.2 13.2 0 17.1-1.3 19.3-6.5 1.2-2.9 1.3-4.4.4-7.1-1.8-5.4-4.2-6.4-14.6-6.4-9.2 0-9.2 0-16.9-31-7.2-28.7-8-31.2-10.7-33.5-4.1-3.5-9.1-3.4-12.7.2z"
        className="fill-primary"
      />
    </svg>
  )
}
